import styled from 'styled-components';

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  inset: 0;
  z-index: 901;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 24px 16px;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  box-sizing: border-box;

  @media (max-width: 485px) {
    width: 90%;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  div:first-child {
    display: flex;
    align-items: center;

    svg {
      border-radius: 50%;
    }
  }

  div:last-child {
    width: 72%;

    h1 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 150%;
      margin: 0;
    }
    h2 {
      font-size: 14px;
      font-weight: 400;
      color: #282832;
      line-height: 165%;
      margin: 0;
    }
  }
`;

export const StarsRow = styled.div`

  gap: 8px;
      max-width: 224px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 16px auto 0;

  div:first-child {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  div:last-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    width: 100%;

    p {
      font-size: 12px;
      font-weight: 400;
      color: #282832;
      line-height: 16px;
      margin: 0;
    }
  }
`;

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  outline: none;
  display: flex;
  align-items: center;

  &:disabled {
    pointer-events: none;
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 24px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;

export const ThankYouText = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  line-height: 156%;
  text-align: center;
  margin: 16px 0 0;
`;
